import { render, staticRenderFns } from "./ExamQuestionAdd.vue?vue&type=template&id=499bd0c5&scoped=true"
import script from "./ExamQuestionAdd.vue?vue&type=script&lang=js"
export * from "./ExamQuestionAdd.vue?vue&type=script&lang=js"
import style0 from "./ExamQuestionAdd.vue?vue&type=style&index=0&id=499bd0c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499bd0c5",
  null
  
)

export default component.exports